import { api } from '@utils/api/api'

export const getTaxesUrl = (): Promise<string> => {
  return api.get('/api/v1/mobile/taxes/preview')
}
